import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#E71C57",
    },
    secondary: {
      main: "#42A74B",
    },
    info: {
      main: "#4E148C",
    },
    success: {
      main: "#4E148C",
    },
    error: {
      main: "#4E148C",
    },
    warning: {
      main: "#4E148C",
    },
  },
});
export default theme;
